export default {
  loginRegisterB: {
    support: "Technical Support:",
    tel: "Contact Phone:",
    mail: "Contact Email:",
    address: "Address:",
    icp: "ICP License No.:"
  }
}